export const TaxPercentage = 21;
  